var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOfferPercentage = function SvgOfferPercentage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 83,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.328 15.836C44.328 3.244 34.386-7 22.164-7 9.942-7 0 3.244 0 15.836c0 12.592 9.942 22.836 22.164 22.836 12.222 0 22.164-10.244 22.164-22.836Zm53.06 21.492c-12.222 0-22.164 10.244-22.164 22.836C75.224 72.756 85.166 83 97.388 83c12.222 0 22.164-10.244 22.164-22.836 0-12.592-9.942-22.836-22.164-22.836ZM84.66-4.196c2.6-3.23 7.331-3.736 10.578-1.172A7.498 7.498 0 0 1 96.414 5.18L36.236 80.186a7.55 7.55 0 0 1-10.578 1.172 7.498 7.498 0 0 1-1.175-10.548L84.66-4.196Z",
    fill: "#FFF5B7"
  })));
};
export default SvgOfferPercentage;